import { z } from 'zod';
import { Validation } from '@mews/framework';
import { ReservationUploadedContractFileSignatureStatus } from '@mews-commander/data-access';
import { ContractsTextKey as TextKey } from '../../ContractsTextKey';
import { FILE_SCHEMA_OPTIONS } from '../common/constants';

export const uploadFileSchema = (existingNames: string[]) =>
    z.object({
        file: Validation.File.Default(FILE_SCHEMA_OPTIONS),
        name: z
            .string()
            .min(1)
            .max(255)
            .refine((name) => !existingNames.includes(name), {
                message: TextKey.ContractFormDuplicateNameValidationMessage,
            }),
        signatureStatus: z
            .nativeEnum(ReservationUploadedContractFileSignatureStatus)
            .or(z.literal(''))
            .optional()
            .transform((value) => (value === '' ? undefined : value)),
        signatureDate: Validation.Date.Iso.optional(),
        signatureDeadlineDate: Validation.Date.Iso.optional(),
        expirationDate: Validation.Date.Iso.optional(),
        notes: z.string().max(1000).optional(),
    });

export type UploadFileDialogFormValues = z.infer<ReturnType<typeof uploadFileSchema>>;
